<template>
  <div class="page-wrap">
    <div class="wraper">
      <img class="t-img" :src="img1" />
      <div class="content-wrap">
        <div class="follow">
          <div class="module-label">关注我们</div>
          <div class="follow-card-box">
            <!-- <div class="follow-card">
              <img src="../../assets/img/douy.png" />
              <div>抖音号</div>
              <div class="name">这就是文华财经</div>
            </div> -->
            <div class="follow-card">
              <img :src="img2" />
              <div>微信号</div>
              <div class="name">匠心文华</div>
            </div>
            <div class="follow-card">
              <img :src="img3" />
              <div>微信号</div>
              <div class="name">文华财经招聘</div>
            </div>
          </div>
        </div>
        <div class="hr">
          <div class="module-label">文华财经人力资源部</div>
          <div class="box">
            <div>咨询电话：</div>
            <div class="tel">
              <div v-for="(item, index) in tel" :key="index">{{item}}</div>
            </div>
          </div>
        </div>
        <div class="address">
          <div class="module-label">公司地址</div>
          <div class="box">
            <div class="address-content" v-for="(item, index) in address" :key="index">
              <div>{{item.name + '：'}}</div>
              <div>{{item.address}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <bottom style="flex: 0 0 2.2rem;"></bottom>
  </div>
</template>

<script>
export default {
  data() {
    return {
      img1: `${process.env.BASE_URL}ImgFiles/top-lxwm_02.png`,
      img2: `${process.env.BASE_URL}ImgFiles/jxwh.png`,
      img3: `${process.env.BASE_URL}ImgFiles/zhaop.png`,
      tel: ["021-50270068  （上海）", "0411-84760066-2 （大连）"],
      wechat: "whzhaopin01",
      address: [
        {
          name: "上海总公司",
          address: "上海市浦东新区源深路419号，国际华城大厦9层",
        },
        {
          name: "大连分公司",
          address: "大连市沙河口区软件园东路23号，软件园15号楼4层",
        },
      ],
    };
  },
};
</script>

<style scoped>
.page-wrap {
  position: absolute;
  bottom: 0;
  overflow-y: auto;
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  z-index: 10;
  background-color: #fff;
}
.content-wrap {
  padding: 0 0.3386rem;
}
.follow {
  margin-top: 0.95rem;
}
.follow-card-box {
  display: flex;
  /* height: 6.517rem;         */
  /* justify-content: space-around;*/
}

.follow-card {
  width: 4.708rem;
  height: 100%;
  padding: 0.475rem 0;
  box-sizing: border-box;
  border: 1px #bfbfbf solid;
  border-radius: 10px;
  box-shadow: -2px 3px 4px rgb(0 0 0 / 20%);

  text-align: center;
  line-height: 1.5;
  font-size: 0.513rem;
  letter-spacing: 1px;
  margin-right: 0.3386rem;
}

.follow-card img {
  margin-bottom: 0.513rem;
  width: 3.566rem;
  height: 3.566rem;
}

.follow-card .name {
  color: rgb(88, 102, 117);
  font-size: 0.577rem;
}
.hr {
  margin-top: 2.59rem;
}
.box {
  position: relative;
  border: 1px #bfbfbf solid;
  border-radius: 10px;
  box-shadow: -2px 3px 4px rgb(0 0 0 / 20%);
  font-size: 0.577rem;
  line-height: 0.9rem;
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  color: #414141;
  transition: all 0.3s;
  -webkit-transition: all 0.3s;
  padding: 0.872rem 1rem 1.206rem 0.564rem;
}
.hr .tel {
  margin-top: 0.706rem;
}
.address {
  margin-top: 2.3rem;
  padding-bottom: 1.642rem;
}
.address-content {
  display: flex;
}
.address-content > div:first-child {
  white-space: nowrap;
}
</style>